import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { VerifyMagicLink } from '@simplybenefits/sb-ui-library';
import { verifyToken } from '../../actions/user.js';
import * as session from "../../services/session.js";

/**
 *
 * @param props
 * @returns {Element}
 * @constructor
 */
const MemberVerifyMagicLink = (props) => {
    const location = useLocation();

    useEffect(() => {
        session.removeToken();
    }, []);

    return (
        <VerifyMagicLink
            location={ location }
            verifyToken={ (...params) => props.dispatch(verifyToken('member', ...params)) }
            whitelabel={ props.whitelabel }
            isLoading={ props.loader.isLoading }
        />
    );
};

/**
 *
 * @param state
 * @returns {{whitelabel}}
 */
const mapStateToProps = (state) => ({
    whitelabel: state.whitelabel,
    loader: state.loader
});

export default connect(mapStateToProps)(MemberVerifyMagicLink);